import React, { useState } from 'react';
import { Menu, Button, Drawer, Grid } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { Link } from "react-router-dom";

const { useBreakpoint } = Grid;

export default function Navbar2() {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const screens = useBreakpoint();

  const showDrawer = () => setDrawerVisible(true);
  const onCloseDrawer = () => setDrawerVisible(false);

  const menuItems = [
    { key: 'home', label: <Link to="/" onClick={onCloseDrawer}>Home</Link> },
    { key: 'hec', label: <Link to="/hec" onClick={onCloseDrawer}>HEC</Link> },
    { key: 'facilities', label: <Link to="/facilities" onClick={onCloseDrawer}>Facilities</Link> },
    { key: 'mess-menu', label: <Link to="/mess-menu" onClick={onCloseDrawer}>Mess Menu</Link> },
  ];

  return (
    <div
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '12px 24px',
        backdropFilter: 'blur(12px)',
        background: 'rgba(0, 21, 41, 0.75)',
        borderBottom: '1px solid rgba(255,255,255,0.1)',
        boxShadow: '0 2px 8px rgba(0,0,0,0.35)',
        color: 'white'
      }}
    >
      <Link to={"/"} className="logo" style={{ display: 'flex', alignItems: 'center', textDecoration:'none' }}>
        <img
          src='images/logo.jpg'
          style={{
            height: '60px',
            marginRight: '12px',
            borderRadius: '8px'
          }}
        />
        <p style={{ color: 'white', fontSize: '18px', margin: 0 }}>
          Hall of Residence 11
        </p>
      </Link>

      {screens.md && (
        <Menu
          mode="horizontal"
          items={menuItems}
          theme="dark"
          style={{
            background: 'transparent',
            borderBottom: 'none',
            fontSize: '16px',
            minWidth: '350px'
          }}
        />
      )}

      {!screens.md && (
        <Button
          type="text"
          icon={<MenuOutlined style={{ color: 'white', fontSize: 22 }} />}
          onClick={showDrawer}
          style={{ color: 'white' }}
        />
      )}

      <Drawer
        title="Navigation"
        placement="right"
        closable={true}
        onClose={onCloseDrawer}
        open={drawerVisible}
      >
        <Menu mode="inline" items={menuItems} />
      </Drawer>
    </div>
  );
}
